import api from "../utils/api";
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_DETAILS_RESET,
  // CLEAR_PROFILE,
} from "./constants/auth";
import { setAlert } from "./alertActions";
import setAuthToken from "../utils/setAuthToken";
import { closeModal } from "./siteActions";
import { CLEAR_PROFILE } from "./constants/profile";
import { ORDER_USERS_LIST_RESET } from "./constants/order";
import {
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LIST_RESET,
} from "./constants/user";

// Load User
export const loadUser = () => async (dispatch: any) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const res = await api.get("/profile/me");

    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  } catch (err: any) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Register User
export const registerUser = (formData: any) => async (dispatch: any) => {
  try {
    const res = await api.post("/users", formData);

    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    });
    dispatch(loadUser());
    dispatch(closeModal());
  } catch (err: any) {
    const errors = err.response?.data?.errors;

    if (errors) {
      errors.forEach((error: any) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: REGISTER_FAIL,
    });
  }
};

// Login User
export const loginUser = (email: string, password: string) => async (
  dispatch: any
) => {
  const body = { email, password };

  try {
    const res = await api.post("/auth", body);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
    dispatch(closeModal());
  } catch (err: any) {
    const errors = err.response?.data?.errors;

    if (errors) {
      errors.forEach((error: any) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: LOGIN_FAIL,
    });
  }
};

export const getUserDetails = (id: string) => async (dispatch: any) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const { data } = await api.get(`/users/${id}`);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    const message =
      error.response?.data?.message || error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logoutUser());
    }
    dispatch({
      type: USER_DETAILS_FAIL,
      payload: message,
    });
  }
};

// Logout
export const logoutUser = () => (dispatch: any) => {
  dispatch({ type: ORDER_USERS_LIST_RESET });
  dispatch({ type: CLEAR_PROFILE });
  dispatch({ type: USER_DETAILS_RESET });
  dispatch({ type: USER_LIST_RESET });
  dispatch({ type: LOGOUT });
};
